import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * RouteFallback — affiché par <Suspense> pendant que React charge le chunk JS
 * d'une route lazy-loaded. Volontairement minimaliste pour ne pas alourdir
 * le bundle initial.
 */
const RouteFallback = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <div className="flex flex-col items-center gap-3 text-slate-400">
      <Loader2 className="w-8 h-8 animate-spin text-blue-400" />
      <p className="text-sm">Chargement…</p>
    </div>
  </div>
);

export default RouteFallback;
